/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTimer = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m14.26 10.294 1.171 1.17-3.43 3.43-1.17-1.17z" /><path fill="currentColor" fillRule="evenodd" d="M15.311 3.655V2h-6.62v1.655h2.481V5.49a8.277 8.277 0 1 0 7.236 2.998l1.659-1.658-1.17-1.17-1.659 1.658a8.24 8.24 0 0 0-4.41-1.828V3.655zM12 20.345a6.62 6.62 0 1 0 0-13.242 6.62 6.62 0 0 0 0 13.242" clipRule="evenodd" /></svg>;
export default SvgTimer;